export default __webpack_public_path__ + "static/media/light_mode.20277577.svg";